import { useId } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import type { CollectionJob } from "@/services/api/collection-jobs";

interface CollectionJobCancelDialogProps {
  open: boolean;
  job: CollectionJob | null;
  isLoading?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function CollectionJobCancelDialog({
  open,
  job,
  isLoading,
  onOpenChange,
  onConfirm,
}: CollectionJobCancelDialogProps) {
  const descriptionId = useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={descriptionId}>
        <DialogHeader>
          <DialogTitle>Cancel Collection Job</DialogTitle>
          <DialogDescription>
            Are you sure you want to cancel this collection job? This action
            cannot be undone.
          </DialogDescription>
        </DialogHeader>
        {job && (
          <div className="py-4">
            <div className="text-sm text-ink-600 space-y-1">
              <p>
                <span className="font-medium text-ink-900">Job ID:</span>{" "}
                {job.id}
              </p>
              <p>
                <span className="font-medium text-ink-900">Status:</span>{" "}
                {job.statusDescription}
              </p>
              {job.triggeredBy && (
                <p>
                  <span className="font-medium text-ink-900">
                    Triggered by:
                  </span>{" "}
                  {job.triggeredBy}
                </p>
              )}
            </div>
          </div>
        )}
        <DialogFooter className="mt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="default"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isLoading ? "Cancelling..." : "Yes, cancel job"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
